import Cookies from 'js-cookie'

const state = {
  sidebar: {
    opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
    withoutAnimation: false
  },
  device: 'desktop',
  isApp: typeof(plus) != 'undefined',
  keepAlive: {},
  facingMode: 'user',
  cameraRP: {
    width: 300,
    height: 900
  }
}

const mutations = {
  TOGGLE_SIDEBAR: state => {
    state.sidebar.opened = !state.sidebar.opened
    state.sidebar.withoutAnimation = false
    if (state.sidebar.opened) {
      Cookies.set('sidebarStatus', 1)
    } else {
      Cookies.set('sidebarStatus', 0)
    }
  },
  CLOSE_SIDEBAR: (state, withoutAnimation) => {
    Cookies.set('sidebarStatus', 0)
    state.sidebar.opened = false
    state.sidebar.withoutAnimation = withoutAnimation
  },
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  CHECK_ISAPP: (state) => {
    state.isApp = (typeof(plus) != 'undefined')
  },
  PUSH_KEEPALIVE: (state, [name, level]) => {
    if(!state.keepAlive[name]) {
      state.keepAlive[name] = level
    }
  },
  PULL_KEEPALIVE: (state, name) => {
    if(state.keepAlive[name]) {
      delete state.keepAlive[name]
    }
  },
  TOGGLE_FACING_MODE: (state) => {
    state.facingMode = (state.facingMode === 'user' ? 'environment' : 'user');
  }
}

const actions = {
  toggleSideBar({ commit }) {
    commit('TOGGLE_SIDEBAR')
  },
  closeSideBar({ commit }, { withoutAnimation }) {
    commit('CLOSE_SIDEBAR', withoutAnimation)
  },
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  checkIsapp({ commit }) {
    // console.log('检查是否app')
    commit('CHECK_ISAPP')
  },
  pushKeepAlive({ commit}, [name, level]) {
    commit('PUSH_KEEPALIVE', [name, level])
  },
  pullKeepAlive({ commit}, name) {
    commit('PULL_KEEPALIVE', name)
  },
  toggleFacingMode({ commit }) {
    commit('TOGGLE_FACING_MODE')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
